import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
};



// WEBPACK FOOTER //
// ./src/store/modules/timesheet/getters.js